



































































import { Component, Prop } from 'vue-property-decorator';
import { isEmpty } from 'lodash';
import { FormRules, Form } from '@ss/mtd-vue';
import { PaginationMixin } from '@/utils/mixin';
import * as api from '@/api';

interface Faq {
    id: number | null;
    title: string;
    content: string;
}

@Component({ name: 'rg-moses-faq' })
export default class RgMosesFaq extends PaginationMixin {
    @Prop({ required: true })
    rgId: number;

    faqs: Array<Faq> = [];

    faqEditingStage: Faq = {
        id: null,
        title: null,
        content: null
    };

    faqEditingFormRules: FormRules = {
        title: [
            { required: true, message: '标题不可为空' },
            { max: 100, message: '常见问题标题字数不可超过100字' }
        ],
        content: [
            { required: true, message: '内容不可为空' },
            {
                pattern: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/,
                message: '请输入请输入有效的URL链接'
            },
            {
                // 安全的URL字符串长度
                // see: https://stackoverflow.com/a/33733386/4747368
                max: 2048,
                message: 'URL链接长度不可超过2048'
            }
        ]
    };

    mounted() {
        this.getMosesFaqs();
    }

    async getMosesFaqs() {
        try {
            const res = await api.rgApi.getMosesFaqs({
                rgId: this.rgId,
                cn: this.currentPage,
                sn: this.limit
            });
            const { code, data } = res;
            this.faqs = data.items || [];
            this.total = data.tn;

            if (code === 200) {
                if (data.tn > 0 && !data.items.length) {
                    this.currentPage -= 1;
                    if (this.currentPage <= 0) {
                        this.currentPage = 1;
                    }
                    this.getMosesFaqs();
                }
            } else {
                this.$mtd.message({ message: res.message, type: 'error' });
            }
        } catch (e) {
            console.log(e);
        }
    }

    handlePageChange(current: number, size: number) {
        this.limit = size;
        this.currentPage = current;
        this.getMosesFaqs();
    }

    startEditingFaq(faqData: any) {
        if (isEmpty(faqData)) {
            // 如果正在添加，直接中止
            const lastItem = this.faqs[this.faqs.length - 1];
            if (lastItem && lastItem.id === null) {
                return;
            }
            const newItem = {
                id: null,
                title: '',
                content: ''
            };
            this.faqs.push(newItem);
            this.faqEditingStage.title = newItem.title;
            this.faqEditingStage.content = newItem.content;
            return;
        }
        // 开始编辑
        this.faqEditingStage.id = faqData.id;
        this.faqEditingStage.title = faqData.title;
        this.faqEditingStage.content = faqData.content;
    }
    cancelEditingFaq(faqData: any) {
        // reset 编辑区
        this.faqEditingStage = { id: null, title: null, content: null };
        if (faqData.id == null) {
            this.faqs.pop();
        }
    }
    deleteFaq(faqData: any) {
        this.$mtd
            .confirm({
                message: '确认删除？',
                onOk: async () => {
                    const res = await api.rgApi.deleteFaq(faqData.id);
                    if (res.code === 200) {
                        this.$mtd.message({ message: '删除成功', type: 'success' });
                        this.getMosesFaqs();
                    } else {
                        this.$mtd.message({ message: '删除失败', type: 'error' });
                    }
                }
            })
            .catch(e => {
                console.log(e);
            });
    }

    validateFaq(): Promise<boolean> {
        return new Promise(resolve => {
            (this.$refs.faqEditingForm as Form)
                .validate(valid => {
                    resolve(valid);
                })
                .catch(e => {
                    console.log(e);
                    resolve(false);
                });
        });
    }

    async saveEditingFaq() {
        const valid = await this.validateFaq();
        if (!valid) return;
        if (this.faqEditingStage.id == null) {
            try {
                const res = await api.rgApi.addMosesFaq({
                    rgId: this.rgId,
                    content: this.faqEditingStage.content,
                    title: this.faqEditingStage.title
                });
                if (res.code === 200) {
                    const idx = this.faqs.map(item => item.id || null).indexOf(this.faqEditingStage.id);
                    const addedFaq = res.data;
                    this.faqs[idx] = { ...addedFaq };
                    this.faqEditingStage = { id: null, title: null, content: null };
                } else {
                    this.$mtd.message({ message: res.message, type: 'error' });
                }
            } catch (e) {
                console.log(e);
            }
        } else {
            try {
                const res = await api.rgApi.updateFaq({
                    rgId: this.rgId,
                    id: this.faqEditingStage.id,
                    title: this.faqEditingStage.title,
                    content: this.faqEditingStage.content,
                    enable: true
                });
                if (res.code === 200) {
                    const idx = this.faqs.map(item => item.id || null).indexOf(this.faqEditingStage.id);
                    const updatedFaq = res.data;
                    this.faqs[idx] = { ...updatedFaq };

                    this.$mtd.message({ message: '修改成功', type: 'success' });
                    this.faqEditingStage = { id: null, title: null, content: null };
                } else {
                    this.$mtd.message({ message: res.message, type: 'error' });
                }
            } catch (e) {
                console.log(e);
            }
        }
    }
    // 设置 faq 是否启用
    async toggleFaqEnable(faqData: any, enable: boolean) {
        const { id } = faqData;
        if (id == null) {
            return;
        }
        const res = await api.rgApi.updateFaq({ ...faqData, enable });
        if (res.code === 200) {
            this.$mtd.message({ message: '设置成功', type: 'success' });
            this.getMosesFaqs();
        }
    }
}
